@let extraCosts = extraCosts$ | async;
@let files = files$ | async;
<fieldset class="plain flex-grow-1" [disabled]="readonly()">
  <form [formGroup]="supplierInvoiceForm">
<kendo-panelbar rcPanelBarNoCollapse [animate]="false" [expandMode]="expandMode">
  <kendo-panelbar-item
    iconClass="rc-icon-file-invoice"
    [title]="'DOCUMENT' | translate | capitalize"
    [expanded]="true">
    <ng-template kendoPanelBarContent>
      <div class="grid template-cols-4">
        @if (supplierInvoice()?.clientInvoiceDocumentNumber) {
          <div class="d-flex flex-column g-col-4">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-label
                labelCssClass="k-form-label"
                [for]="docNr"
                [text]="'LINKED_SALES_INVOICE' | translate | capitalize"></kendo-label>
              <button #docNr kendoButton class="link-button !k-text-no-underline p-0 h-unset"
                      (click)="updateLinkedSalesInvoice()">
                <span class="!k-text-underline underline-offset-2">
                  {{ supplierInvoice()?.clientInvoiceDocumentNumber }}</span> <i
                class="rc-icon-pencil !k-text-no-underline fs-16 ps-8 fc-neutral-800"></i></button>
            </kendo-formfield>
          </div>
        }

        <div class="d-flex flex-column g-col-4">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="invoiceDate"
              [text]="('INVOICE_NUMBER' | translate | capitalize) + ' ' + ('SUPPLIER' | translate)"></kendo-label>
            <div class="d-flex">
              <span #invoiceDate>{{ supplierInvoice()?.documentNumber }}</span>
              @if (files?.length) {
                <a
                  class="ps-6 text-decoration-none d-flex align-items-center"
                  [href]="fileUrl(files![0])"
                  target="_blank"
                  rel="noopener"
                  (click)="openFileInWindow($event, files![0])">
                  <i class="rc-icon-eye fc-base-black mb-2"></i>
                </a>
              }
            </div>
          </kendo-formfield>
        </div>
        <div class="d-flex flex-column g-col-4">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="invoiceDate"
              [text]="'INVOICE_DATE' | translate | capitalize"></kendo-label>
            <div><span #invoiceDate>
              {{ supplierInvoice()?.invoiceDate ? (supplierInvoice()?.invoiceDate | kendoDate :  "dd/MM/yyyy") : '-' }}</span>
            </div>
          </kendo-formfield>
        </div>
        <div class="d-flex flex-column g-col-4">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="invoiceWeek"
              [text]="'INVOICE_WEEK' | translate | capitalize"></kendo-label>
            <div><span #invoiceWeek>{{ supplierInvoice()!.invoiceDateAsWeekFormat ?? '-' }}</span></div>
          </kendo-formfield>
        </div>
        <div class="d-flex flex-column g-col-4">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="dueDate"
              [text]="'DUE_DATE' | translate | capitalize"></kendo-label>
            <div><span #dueDate>
              {{ supplierInvoice()!.dueDate ? (supplierInvoice()!.dueDate | kendoDate :  "dd/MM/yyyy") : '-' }}</span>
            </div>
          </kendo-formfield>
        </div>
        <div class="d-flex flex-column g-col-4">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="reference"
              [text]="('REFERENCES' | translate | capitalize) + ' ' + ('ORDER' | translate)"></kendo-label>
            <div #reference class="d-flex flex-column">
              @for (ref of supplierInvoice()?.references; track ref) {
                <span>{{ ref }}</span>
              }
            </div>
          </kendo-formfield>
        </div>
      </div>
    </ng-template>
  </kendo-panelbar-item>
  <kendo-panelbar-item
    iconClass="rc-icon-skyscraper"
    [title]="'SUPPLIER' | translate | capitalize">
    <ng-template kendoPanelBarContent>
      <div class="grid template-cols-4">
        <div class="d-flex flex-column g-col-4">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="rcSupplier"
              [text]="('SUPPLIER' | translate | capitalize) + ' ROYAL CROWN'"></kendo-label>
            <a #rcSupplier class="rc-string-button !k-text-no-underline p-0 h-unset"
               [href]="supplierInvoice()!.supplier"
               target="_blank" [rel]="'noopener noreferrer'"><span
              class="!k-text-underline underline-offset-2">{{ supplierInvoice()?.supplierName }}</span> <i
              class="rc-icon-external-link !k-text-no-underline fs-16 ps-8 fc-neutral-800"></i></a>
          </kendo-formfield>
        </div>
        <div class="d-flex flex-column g-col-4">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="address"
              [text]="('ADDRESS' | translate | capitalize)"></kendo-label>
            <div #address class="d-flex flex-column">
              <span>{{ supplierInvoice()?.supplierAddressStreet }}</span>
              <span>{{ supplierInvoice()?.supplierAddressCity }}</span>
            </div>
          </kendo-formfield>
        </div>
        <div class="d-flex flex-column g-col-4">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="vat"
              [text]="('VAT_NUMBER' | translate | capitalize)"></kendo-label>
            <div #vat class="d-flex flex-column">
              <span>{{ supplierInvoice()?.supplierVatNumber }}</span>
            </div>
          </kendo-formfield>
        </div>
      </div>
    </ng-template>
    >
  </kendo-panelbar-item>
  <kendo-panelbar-item
    iconClass="rc-icon-truck-delivery"
    [title]="'DELIVERY' | translate | capitalize">
    <ng-template kendoPanelBarContent>
      <div class="grid template-cols-4">
        <div class="d-flex flex-column g-col-4">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="address"
              [text]="('DELIVERY_ADDRESS' | translate | capitalize)"></kendo-label>
            <div #address class="d-flex flex-column">
              <span>{{ supplierInvoice()?.deliveryAddressName }}</span>
              <span>{{ supplierInvoice()?.deliveryAddressStreet }}</span>
              <span>{{ supplierInvoice()?.deliveryAddressPostalCode }} {{ supplierInvoice()?.deliveryAddressCity }} {{ supplierInvoice()?.deliveryAddressUnit }}</span>
              <span>{{ supplierInvoice()?.deliveryAddressCountry }}</span>
            </div>
          </kendo-formfield>
        </div>

        <div class="d-flex flex-column g-col-4">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="deliveryDocumentNumbers"
              [text]="('DELIVERY_RECEIPT_NUMBER' | translate | capitalize)"></kendo-label>
            <div #deliveryDocumentNumbers>
              @if (supplierInvoice()?.deliveryDocumentNumbers?.length) {
                <div class="d-flex flex-column">
                  @for (number of supplierInvoice()?.deliveryDocumentNumbers; track number) {
                    <span>{{ number ?? '-' }}</span>
                  }
                </div>
              } @else {
                <span>-</span>
              }
            </div>
          </kendo-formfield>
        </div>
        <div class="d-flex flex-column g-col-4">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="vat"
              [text]="('DELIVERY_DATE' | translate | capitalize)"></kendo-label>
            <div #vat class="d-flex flex-column">
              <span>{{ supplierInvoice()?.deliveryDate  | kendoDate : 'dd/MM/yyyy' }}</span>
            </div>
          </kendo-formfield>
        </div>
      </div>
    </ng-template>
  </kendo-panelbar-item>
  <kendo-panelbar-item
    iconClass="rc-icon-adjustments-horizontal"
    [title]="'CHARACTERISTICS' | translate | capitalize">
    <ng-template kendoPanelBarContent>
      <div class="grid template-cols-4">
        <div class="d-flex flex-column g-col-4">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="uploaded_by"
              [text]="('UPLOADED_BY' | translate | capitalize)"></kendo-label>
            <div #uploaded_by class="d-flex flex-column">
              <span>{{ supplierInvoice()?.uploadedBy }}</span>
              <span>{{ supplierInvoice()?.createdOn | kendoDate : 'dd/MM/yyy HH:mm' }}</span>
            </div>
          </kendo-formfield>
        </div>
        <div class="d-flex flex-column g-col-4">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="uploaded_by"
              [text]="('LAST_UPDATED_BY' | translate | capitalize)"></kendo-label>
            <div #uploaded_by class="d-flex flex-column">
              <span>{{ supplierInvoice()?.lastUpdatedBy }}</span>
              <span>{{ supplierInvoice()?.updatedOn | kendoDate : 'dd/MM/yyy HH:mm' }}</span>
            </div>
          </kendo-formfield>
        </div>
        <div class="g-col-4 d-flex flex-column">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="tagsview"
              [text]="'TAGS' | translate | uppercase"></kendo-label>

            <kendo-multiselect
              rcMultiSelectWrapPadding
              [data]="(tags$ | async) ?? []"
              [valueField]="'@id'"
              [textField]="'name'"
              [filterable]="true"
              (filterChange)="filterTags($event)"
              (valueChange)="updateTags($event)"
              [valuePrimitive]="true"
              rcValidation
              formControlName="tags"
              #tagsview></kendo-multiselect>
          </kendo-formfield>
        </div>
        <div class="d-flex flex-column g-col-4">
          <kendo-formfield showHints="initial" showErrors="initial">
            <kendo-label
              labelCssClass="k-form-label"
              [for]="doNotInvoice"
              [text]="('DO_NOT_INVOICE' | translate | capitalize)"></kendo-label>
            <kendo-switch
              #doNotInvoice
              [checked]="!!supplierInvoice()?.doNotInvoice"
              [offLabel]="''"
              [onLabel]="''"
              (valueChange)="updateDoNotInvoice($event)"
              [readonly]="readonly()"
              [disabled]="isDoNotInvoiceSwitchLocked()"
            />
          </kendo-formfield>
        </div>
      </div>
    </ng-template>
  </kendo-panelbar-item>
  <kendo-panelbar-item iconClass="rc-icon-coin-euro" [title]="'EXTRA_COSTS' | translate | capitalize">
    <ng-template kendoPanelBarContent>

      @if (extraCosts) {
        <div class="grid template-cols-4">
          <div class="g-col-4 d-flex flex-column">
            <div class="grid template-cols-4 gap-8">
              @for (cost of extraCosts; track cost['@id']) {
                <rc-document-fee-card
                  [fee]="cost"
                  [vatCodeEditable]="!isSupplierInvoiceLocked() && !readonly()"
                  (vatCodeChange)="updateTotals.emit(true)" />
              }
            </div>
<!--            <button-->
<!--              type="button"-->
<!--              class="me-2 ms-auto link-button"-->
<!--              kendoButton-->
<!--              fillMode="link"-->
<!--              [disabled]="isSupplierInvoiceLocked() || readonly()"-->
<!--              (click)="createExtraCost()">-->
<!--              + {{ "ADD_ENTITY" | translate: { entity: ("EXTRA_COST" | translate) } | capitalize }}-->
<!--            </button>-->
          </div>
        </div>
      } @else {
        <kendo-loader [type]="'converging-spinner'"></kendo-loader>
      }
    </ng-template>
  </kendo-panelbar-item>
  <kendo-panelbar-item
    iconClass="rc-icon-paperclip"
    [title]="'ATTACHMENTS' | translate | capitalize">
    <ng-template kendoPanelBarContent>
      <div class="grid template-cols-4">
        <div class="d-flex flex-column g-col-4">
          <rc-file-upload
            [wrapperClasses]="'flex-column'"
            [uploadUrl]="uploadUrl"
            [isLoading]="loading()"
            (updated)="markAsDirty($event)"
            [attachments]="supplierInvoiceForm.controls.media.value"
            [disabled]="isSupplierInvoiceLocked() || readonly()"
            >
          </rc-file-upload>
        </div>
      </div>
    </ng-template>
  </kendo-panelbar-item>
  <kendo-panelbar-item
    iconClass="rc-icon-linked-files"
    [title]="'ASSOCIATIONS' | translate | capitalize">
    <ng-template kendoPanelBarContent>
      <rc-document-links [documentIri]="supplierInvoice()?.['@id']!"></rc-document-links>
    </ng-template>
  </kendo-panelbar-item>
  </kendo-panelbar>
  </form>
</fieldset>
